import { useContext } from 'react';

import { ImpersonateContext } from '../context/impersonateContext';


export const useImpersonate = () => useContext(ImpersonateContext);
